// Function for enabling and disabling scroll
// Usage: import disableScroll from 'utils/disableScroll';
// Usage: disableScroll.on() or disableScroll.off()

const disableScroll = {
    on: () => {
        window.document.documentElement.style.overflow = 'hidden';
    },
    off: () => {
        window.document.documentElement.style.overflow = 'unset';
    }
};

export default disableScroll;
